import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { Container } from '../styled.js';
import { jsx } from 'react/jsx-runtime';
import { AiBorderStackingOrderGuard } from '../../../foundation/theme/AiBorderStackingOrderGuard/index.js';
import { Tooltip } from '../../Tooltip/Tooltip/index.js';

function Avatar(props) {
  var children = props.children,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? 'circle' : _props$shape,
    _props$solid = props.solid,
    solid = _props$solid === void 0 ? false : _props$solid,
    className = props.className,
    tooltip = props.tooltip;
  return /*#__PURE__*/jsx(AiBorderStackingOrderGuard, {
    guard: appearance === 'ai',
    children: /*#__PURE__*/jsx(Tooltip, _extends({
      disabled: !tooltip
    }, tooltip, {
      children: /*#__PURE__*/jsx(Container, {
        $size: size,
        $appearance: appearance,
        $shape: shape,
        className: className,
        $solid: solid,
        children: children
      })
    }))
  });
}

export { Avatar };
